import { type JSX, ButtonHTMLAttributes } from "react";
import cn from "classnames";
import { Loader } from "../loader";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  appearance?: "primary" | "secondary" | "danger" | "brand";
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
  size?: "sm" | "md" | "lg";
  fullWidth?: boolean;
  isLoading?: boolean;
}

const appearanceClassName = {
  primary: "bg-[#2c2c2c] border border-[#2c2c2c] text-[#f5f5f5]",
  secondary: "bg-[#e3e3e3] border border-[#767676] text-eerie-black",
  danger: "bg-[#e12424] border border-[#e12424] text-white",
  brand: "bg-primary border border-primary text-white",
};

const sizeClassName = {
  sm: "px-4 py-2 h-8",
  md: "p-3 h-[43px]",
  lg: "p-4 h-[53px]",
};

export const Button = (props: ButtonProps): JSX.Element => {
  const {
    children,
    className,
    appearance = "primary",
    size = "md",
    fullWidth,
    type = "button",
    isLoading,
    disabled,
    ...otherProps
  } = props;

  return (
    <button
      className={cn(
        "box-border flex items-center justify-center gap-3 rounded-lg text-base leading-[120%] tracking-[-0.32px] transition-all duration-200",
        "enabled:cursor-pointer enabled:hover:opacity-90 disabled:opacity-60",
        appearanceClassName[appearance],
        sizeClassName[size],
        fullWidth && "w-full",
        className,
      )}
      type={type}
      disabled={disabled || isLoading}
      {...otherProps}
    >
      {children}
      {isLoading && <Loader appearance={appearance} className={cn("h-[15px] w-[15px] border-t border-r")} />}
    </button>
  );
};
